/**
 * Roll-off order details driver task statuses (UI/domain).
 * Use {@link parseRollOffDriverTaskStatus} at the API boundary to narrow strings to this union.
 */
export const RollOffDriverTaskStatuses = [
    'PENDING',
    'EN_ROUTE',
    'IN_PROGRESS',
    'SERVICING',
    'COMPLETE',
    'COMPLETE_WITH_ISSUES',
    'FAILED',
    'CANCELLED',
];
export const RollOffDriverTaskStatusLabels = {
    PENDING: 'Open',
    EN_ROUTE: 'En Route',
    IN_PROGRESS: 'In progress',
    SERVICING: 'Servicing',
    COMPLETE: 'Complete',
    COMPLETE_WITH_ISSUES: 'Complete w/ issue',
    FAILED: 'Failed',
    CANCELLED: 'Canceled',
};
const rollOffStatusSet = new Set(RollOffDriverTaskStatuses);
export const scheduleNotStartedStatuses = new Set(['UNASSIGNED', 'ASSIGNED_TO_DRIVER']);
export const RollOffDriverTaskTypes = ['DELIVERY', 'PICKUP', 'SERVICE', 'DUMP', 'RELOCATE'];
export const RollOffDriverTaskTypeLabels = {
    DELIVERY: 'Delivery',
    PICKUP: 'Pickup',
    SERVICE: 'Service',
    DUMP: 'Dump',
    RELOCATE: 'Relocate',
};
/**
 * Returns the status when `raw` is a {@link RollOffDriverTaskStatus}; otherwise null (caller may skip the row).
 */
export function parseRollOffDriverTaskStatus(raw) {
    if (raw == null || raw === '') {
        return null;
    }
    return rollOffStatusSet.has(raw) ? raw : null;
}
//# sourceMappingURL=roll-off-driver-task-status.js.map